import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=1066d76c&scoped=true&"
import script from "./Activity.vue?vue&type=script&lang=js&"
export * from "./Activity.vue?vue&type=script&lang=js&"
import style0 from "./Activity.vue?vue&type=style&index=0&id=1066d76c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066d76c",
  null
  
)

export default component.exports